import _Space from './space';
import withInstall from '../utils/withInstall';

import './style';

export * from './type';

export const Space = withInstall(_Space);

export default Space;
